export const STORAGE_KEY = 'db_transfer'

export const POLL_INTERVAL_MS = 1000

// StoryGraph surface styles
export const STORYGRAPH_PILL_STYLE = 'display:inline-block; padding:2px 12px; background:#f0f7f2; color:#2e7d32; border:1px solid #2e7d32; border-radius:20px; font-size:12px; font-weight:bold; text-decoration:none; vertical-align:middle; cursor:pointer; margin-left:10px;'
export const STORYGRAPH_TAG_STYLE = 'display:inline-block; padding:2px 8px; background:#f0f7f2; color:#2e7d32; border:1px solid #2e7d32; border-radius:4px; font-size:10px; font-weight:bold; text-decoration:none; margin-left:8px; vertical-align:middle;'
export const STORYGRAPH_INLINE_LINK_STYLE = 'display:inline; color:#2e7d32; font-size:11px; font-weight:500; text-decoration:underline; text-underline-offset:2px; margin-left:8px; opacity:0.75; vertical-align:middle;'

// Douban surface styles
export const DOUBAN_ASIDE_LINK_STYLE = 'display:inline-block; color:#3377aa; font-size:13px; text-decoration:none; border-bottom:1px solid rgba(51,119,170,0.35);'
export const DOUBAN_ASIDE_LINK_IN_SECTION_STYLE = DOUBAN_ASIDE_LINK_STYLE
export const DOUBAN_ASIDE_CARD_STYLE = 'padding:18px 16px; background-color:rgb(246, 246, 242); margin:20px auto;'
export const DOUBAN_ASIDE_CARD_TITLE_STYLE = 'font-size:15px; margin:0 0 10px;'

export interface TransferData {
  title: string
  originalTitle: string
  author: string
  language: string
  publisher: string
  isbn: string
  pages: string
  pubDate: string
  format: string
  desc: string
  rating: string
  review: string
  coverUrl?: string
}
